import React from 'react';
import classnames from 'classnames';
import Card from 'scy/Card';
import { CarouselProductGrid } from 'components/ProductGrid';
import { SmallUppercase } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function RecommendationsCard({
  className,
  title,
  list,
  trackCategory,
  sliderSettings
}) {
  if (!list || !list.length) return null;

  return (
    <Card
      tag="section"
      className={classnames(styles.recommendationsCard, className)}
    >
      <SmallUppercase
        tag="h2"
        marginClass={`${margin.top_0} ${margin.bottom_sm}`}
      >
        {title}
      </SmallUppercase>
      <CarouselProductGrid
        products={list}
        sliderSettings={sliderSettings}
        trackCategory={trackCategory}
      />
    </Card>
  );
}
